/* EFP Graphics — Full Custom configurator (template product.efp-configurator)
A presentation layer around Zepto Product Personalizer. It never creates, removes, renames or disables
Zepto inputs; it shows/hides Zepto's own wrappers per step (CSS, keyed on Zepto's field classes), switches
views through Zepto's own view handler, and checks required fields before Zepto's add-to-cart validation.
Step 1 is a structured bike selector (category > brand > model > year) fed by efp-configurator-catalog.js;
every choice is written into Zepto's own Category / Brand / Model Name / Year fields, and nothing can be
continued or added to cart unless those fields hold exactly what the customer picked. Every listed model can
be ordered; "Other" lets the customer type a model (or brand and model) that is not listed.
Since 2026-10-14 the same layer serves every Full Custom product (Moto 50cc / MX, Streetbike, Adventure,
E-Bike): a product shows the categories of its own Zepto Category field, a product with one category skips
that choice, and two optional hidden Zepto fields carry a price per model ("Template fee": the template's
price tier; "Kit type": Race / Sport or Roadster / Naked). Without those fields nothing is charged extra.
Since the evening of 2026-10-14 the category is a choice between products: the intro's category links
(.efp-catnav, snippet efp-cfg-intro) open the configurator of that category, and the bike selector only offers the
categories of the product it is on. Every choice is also reported for market research (see track()).
Since 2026-10-15 a product can run in helmet mode (data-mode="helmet" and data-models="RO9|Alpha V8" on the
intro, set in snippet efp-cfg-intro): step 1 is then only the choice of helmet model, written into Zepto's Model
Name; Zepto's category, brand and year fields (copied over from the bike products) are not shown and do not block.
Also since 2026-10-15: a linked copy of an image field in another view that has no options of its own is given the
options of its original (see fixLinkedImageGroups()), so the 2D view follows the chosen texture.
If Zepto is not found within 20 s, nothing changes. If the catalog or Zepto's bike fields are missing,
Zepto's own fields stay visible as before. */
(function () {
'use strict';
/* Zepto's own "sticky live" preview moves the real preview into its floating box (.pplrabs_live) on phones. This page
has its own sticky preview and hides that box, so the moved canvas measured 0 x 0; Zepto then sized every child of
<body> to the size of the page, and the screen went white (seen 2026-10-14 on E-Bike, mobile, after choosing a model).
Zepto's switch for that feature is window.pplrStickyLive. */
window.pplrStickyLive = false;
var STEPS = [
{ n: 1, num: '01', label: 'Your bike', title: 'Choose your bike',
text: 'Pick your category, brand, model and year, so we make the kit for exactly what you ride.' },
{ n: 2, num: '02', label: 'Your design', title: 'Design your graphics',
text: 'Build your kit layer by layer: a design, its colour, a texture and a background. The preview updates with every choice.' },
{ n: 3, num: '03', label: 'Final details', title: 'Final details',
text: 'Add your name and number, pick the fonts and text colour, and tell us anything else we should know.' }
];
var S1 = ['pplr-category', 'pplr-brand', 'pplr-model', 'pplr-year', 'pplr-vehicle', 'pplr-bike'];
var S2 = ['pplr-design', 'pplr-texture', 'pplr-background', 'pplr-gradient'];
/* Hidden price fields the layer fills from the chosen model (Zepto field names "Template fee" and "Kit type";
not "Model ..." or "Bike ...", whose classes would count as bike fields). */
var FEE = { tpl: 'pplr-template-fee', type: 'pplr-kit-type' };
var TIER_NAMES = ['Included', 'Level 1', 'Level 2', 'Level 3'];
var VIEWS = [[/main/i, 'On bike', 'bike'], [/2d/i, '2D template', 'sticker']];
var REF_NAME = 'properties[_Template]';
var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
var form, root, head, intro, stepBtns = [], summary, nav, msg, backBtn, nextBtn, current = 1;
var CAT = null;
var bike = null, combos = {}, otherField, otherInput, otherLabel, refInput, catBtns = [], feeNote = null;
var OTHER = 'other', OTHER_BRAND = '__other';
/* Catalog entries that are not a whole kit for one model (parts-only templates, titles without a model). */
var HIDE_MODEL = /^Model not specified|\s-\s(Frame|Shrouds)$/i;
var sel = { cat: '', brand: '', model: -1, year: '', other: '' };
/* Helmet mode: { models: ['RO9', 'Alpha V8'] } when the intro asks for it, otherwise null. */
var HELMET = null, helmetField = null;
var HELMET_STEP = { n: 1, num: '01', label: 'Your helmet', title: 'Choose your helmet',
text: 'Pick your helmet model, so we make the kit for exactly the helmet you wear.' };

function tokens(el) { return String(el.className || '').split(/\s+/); }
function hasPrefix(el, list) {
var t = tokens(el);
for (var i = 0; i < t.length; i++) for (var j = 0; j < list.length; j++) if (t[i].indexOf(list[j]) === 0) return true;
return false;
}
function stepOf(w) { return hasPrefix(w, S1) ? 1 : hasPrefix(w, S2) ? 2 : 3; }
function zeptoHidden(w) {
if (!w.isConnected) return true;
if (w.classList.contains('p_h_d_p') || w.classList.contains('cstmfy_static')) return true;
var e = w;
while (e && e !== root) { if (e.style && e.style.display === 'none') return true; e = e.parentElement; }
return false;
}
function isFee(w) { return hasPrefix(w, [FEE.tpl, FEE.type]); }
function wrappers(step) {
var all = root.querySelectorAll('.pplr-wrapper'), out = [];
for (var i = 0; i < all.length; i++) {
if (zeptoHidden(all[i]) || isFee(all[i])) continue;
if (!step || stepOf(all[i]) === step) out.push(all[i]);
}
return out;
}
function labelOf(w) {
var l = w.querySelector('.pplrlabel');
if (!l) return 'This option';
var txt = '';
for (var i = 0; i < l.childNodes.length; i++) if (l.childNodes[i].nodeType === 3) txt += l.childNodes[i].textContent;
txt = txt.replace(/\s+/g, ' ').trim() || l.textContent.trim();
if (bike) { if (/^brand\b/i.test(txt)) return 'Brand'; if (/^model name$/i.test(txt)) return 'Model'; }
return txt;
}
function isMissing(w) {
var bad = false;
w.querySelectorAll('input[required]:not([disabled]), textarea[required]:not([disabled]), select[required]:not([disabled])').forEach(function (i) {
if (bad || i.classList.contains('pplr_hide_duplicate')) return;
if (i.type === 'file' || i.classList.contains('fileupload')) { if (!i.name || w.querySelector('.pplr-file-item')) return; }
if (String(i.value || '').trim() === '') bad = true;
});
if (!bad) w.querySelectorAll('.pplr_imgg.cstmfy_c_required:not([disabled]), .pplr_select.cstmfy_c_required:not([disabled]), .pplrjscolor.cstmfy_c_required:not([disabled])').forEach(function (i) {
if (String(i.value || '') === '') bad = true;
});
return bad;
}
/* A "missing" item is { label, node, focus } so Zepto wrappers and the bike selector report the same way. */
function item(w) { return { label: labelOf(w), node: w, focus: function () { focusField(w); } }; }
function missingIn(step) {
if (step === 1 && bike) return stepOneMissing();
return wrappers(step).filter(isMissing).map(item);
}
function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

function build() {
head = el('div', 'efp-cfg');
head.id = 'efp-configurator';
head.appendChild(el('p', 'efp-cfg__eyebrow', 'Configurator &middot; 3 steps'));
var navEl = el('nav', 'efp-steps'); navEl.setAttribute('aria-label', 'Configuration steps');
var ol = el('ol');
STEPS.forEach(function (s) {
var li = el('li');
var b = el('button', 'efp-step',
'<span class="efp-step__num">' + s.num + '<svg class="efp-step__check" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
'<span class="efp-step__label">' + s.label + '</span>');
b.type = 'button'; b.dataset.step = s.n;
b.addEventListener('click', function () { requestStep(s.n); });
li.appendChild(b); ol.appendChild(li); stepBtns.push(b);
});
navEl.appendChild(ol); head.appendChild(navEl);
intro = el('div', 'efp-step-intro', '<h2 tabindex="-1"></h2><p></p>');
head.appendChild(intro);
root.parentNode.insertBefore(head, root);
summary = el('section', 'efp-summary'); summary.setAttribute('aria-label', 'Your configuration');
root.parentNode.insertBefore(summary, root.nextSibling);
nav = el('div', 'efp-cfg__nav');
msg = el('p', 'efp-cfg__msg'); msg.setAttribute('role', 'alert'); msg.hidden = true;
var row = el('div', 'efp-cfg__navrow');
backBtn = el('button', 'efp-btn efp-btn--ghost', '&larr; Back'); backBtn.type = 'button';
nextBtn = el('button', 'efp-btn efp-btn--primary', 'Continue &rarr;'); nextBtn.type = 'button';
backBtn.addEventListener('click', function () { go(current - 1, true); });
nextBtn.addEventListener('click', function () { requestStep(current + 1); });
row.appendChild(backBtn); row.appendChild(nextBtn);
var errWrap = el('div', 'efp-cfg__error'); errWrap.appendChild(msg);
nav.appendChild(errWrap); nav.appendChild(row);
form.appendChild(nav);
}
function setMsg(list, text) {
form.querySelectorAll('.efp-missing').forEach(function (w) { w.classList.remove('efp-missing'); });
if (!list || !list.length) { msg.hidden = true; msg.textContent = ''; return; }
list.forEach(function (m) { if (m.node) m.node.classList.add('efp-missing'); });
var names = list.map(function (m) { return m.label; }).filter(function (v, i, a) { return v && a.indexOf(v) === i; });
msg.textContent = text || list[0].text || ('Please complete ' + (names.length > 1 ? 'these fields' : 'this field') + ': ' + names.join(', ') + '.');
msg.hidden = false;
}
/* Height of a fixed or sticky header at the top of the window (0 when there is none). */
function stickyTop() {
var e = document.elementFromPoint(Math.round(window.innerWidth / 2), 2), b = 0;
while (e && e !== document.documentElement) { var p = getComputedStyle(e).position; if (p === 'fixed' || p === 'sticky') b = Math.max(b, e.getBoundingClientRect().bottom); e = e.parentElement; }
return b > 0 && b < window.innerHeight / 2 ? b : 0;
}
/* Scrolls the step header into view. Normally only when it is out of sight; with force (the "Start customizing"
button) always, so the step is at the top of the window wherever the page was scrolled to. */
function scrollToHead(force) {
var top = head.getBoundingClientRect().top;
var offset = stickyTop();
/* On phones the preview sticks to the top while the page scrolls; the step goes just below it. Once it is stuck,
stickyTop() already measures it, so take the larger of the two instead of adding both. */
if (window.innerWidth < 768) {
var media = document.querySelector('.hdt-section--feature-product .hdt-product-media-wrapps');
var mp = media && getComputedStyle(media).position;
if (mp === 'sticky' || mp === 'fixed') offset = Math.max(offset, (parseFloat(getComputedStyle(media).top) || 0) + media.getBoundingClientRect().height);
}
offset += 12;
if (force ? Math.abs(top - offset) > 4 : (top < offset || top > window.innerHeight * 0.6)) {
window.scrollTo({ top: window.pageYOffset + top - offset, behavior: reduceMotion ? 'auto' : 'smooth' });
}
}
function go(n, focusTitle, force) {
n = Math.max(1, Math.min(3, n));
current = n;
form.setAttribute('data-efp-step', String(n));
/* Also on the body, so the preview (outside the form) can follow the step: on phones it only sticks from step 2. */
document.body.setAttribute('data-efp-step', String(n));
var s = STEPS[n - 1];
intro.querySelector('h2').textContent = s.title;
intro.querySelector('p').textContent = s.text;
stepBtns.forEach(function (b, i) {
var k = i + 1;
b.classList.toggle('is-current', k === n);
b.classList.toggle('is-done', k < n && missingIn(k).length === 0);
b.classList.toggle('is-upcoming', k > n);
if (k === n) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
b.setAttribute('aria-label', 'Step ' + k + ' of 3: ' + STEPS[i].label + (k < n ? ' (completed)' : k === n ? ' (current)' : ''));
});
backBtn.hidden = n === 1;
nextBtn.hidden = n === 3;
setMsg(null);
closeCombos();
if (n === 3) renderSummary();
syncSelected();
enhanceSwatches();
if (n === 2) track('efp_bike', bikeData());
if (n === 3) track('efp_design', designData());
if (focusTitle) { scrollToHead(force); intro.querySelector('h2').focus({ preventScroll: true }); }
}
function requestStep(n) {
if (n <= current) { go(n, true); return; }
for (var k = current; k < n; k++) {
var miss = missingIn(k);
if (miss.length) {
if (k !== current) go(k, true);
setMsg(miss);
miss[0].focus();
return;
}
}
go(n, true);
}
function focusField(w) {
var f = w.querySelector('input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), .pplr-swatch-element, .pplr-selecter-selected');
if (f && f.focus) f.focus({ preventScroll: false });
}
function valueOf(w) {
if (w.querySelector('.pplr-file-item')) return { text: 'Image added' };
var ins = w.querySelectorAll('[name^="properties["]');
for (var i = 0; i < ins.length; i++) {
var inp = ins[i];
if (/^properties\[_/.test(inp.name) || inp.type === 'file' || inp.disabled && !inp.classList.contains('pplr-empty-value-disabled')) continue;
var v = String(inp.value || '').trim();
if (v) return { text: v, color: inp.getAttribute('data-value') && /^#|rgb/.test(inp.getAttribute('data-value')) ? inp.getAttribute('data-value') : null };
}
return null;
}
/* The total is the theme's own sale price, which Zepto keeps at base price + paid options. (Zepto's
".a_p_t" line is the options-only subtotal, not the total.) */
function priceEl() { return document.querySelector('.hdt-section--feature-product .hdt-product__price hdt-price .hdt-money, .hdt-section--feature-product hdt-price .hdt-money'); }
function totalText() {
var p = priceEl();
return p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
}
function renderSummary() {
var rows = '';
[1, 2, 3].forEach(function (k) {
wrappers(k).forEach(function (w) {
var v = valueOf(w);
if (!v) return;
var text = v.text.length > 60 ? v.text.slice(0, 57) + '…' : v.text;
rows += '<dt>' + esc(labelOf(w)) + '</dt><dd>' + (v.color ? '<span class="efp-dot" style="background:' + esc(v.color) + '"></span>' : '') + esc(text) + '</dd>';
});
});
var total = totalText();
summary.innerHTML = '<h3>Your configuration</h3><dl>' + rows + '</dl>' +
(total ? '<div class="efp-summary__total"><span>Total</span><strong>' + esc(total) + '</strong></div>' : '');
}
function syncSelected() {
wrappers(current).forEach(function (w) {
var lbl = w.querySelector('.pplrlabel');
if (!lbl || lbl.querySelector('.pplr_option_text_span')) return;
var s = w.querySelector('.pplr-swatch-element.selected');
var name = s ? (s.getAttribute('data-name') || s.getAttribute('data-val') || '') : '';
var tag = lbl.querySelector('.efp-sel');
if (!name) { if (tag) tag.remove(); return; }
if (!tag) { tag = el('span', 'efp-sel'); lbl.appendChild(tag); }
if (tag.textContent !== name) tag.textContent = name;
});
}
function enhanceSwatches() {
root.querySelectorAll('.pplr-swatch-element, .pplr-selecter-selected, .pplr-selecter-item').forEach(function (s) {
if (!s.hasAttribute('tabindex')) s.setAttribute('tabindex', '0');
if (!s.hasAttribute('role')) s.setAttribute('role', 'button');
var n = s.getAttribute('data-name') || s.getAttribute('data-val');
if (n && !s.hasAttribute('aria-label')) s.setAttribute('aria-label', n);
if (s.classList.contains('pplr-swatch-element')) s.setAttribute('aria-pressed', s.classList.contains('selected') ? 'true' : 'false');
});
var apt = root.querySelector('.a_p_t_c'); if (apt) apt.setAttribute('aria-hidden', 'true');
}
var rafPending = false;
function onChange() {
if (rafPending) return;
rafPending = true;
setTimeout(function () {
rafPending = false;
if (!msg.hidden) { var miss = missingIn(current); setMsg(miss.length ? miss : null); }
syncSelected(); enhanceSwatches();
fixLinkedImageGroups();
if (bike && HELMET) { relaxBikeFields(); if (sel.cat && !helmetInSync()) pushHelmet(); }
else if (bike) { hideFeeFields(); renderFees(); }
if (current === 3) renderSummary();
}, 40);
}
function bindForm() {
root.addEventListener('change', onChange);
root.addEventListener('input', onChange);
root.addEventListener('click', function () { setTimeout(onChange, 60); });
root.addEventListener('keydown', function (e) {
if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.pplr-swatch-element, .pplr-selecter-selected, .pplr-selecter-item')) {
e.preventDefault(); e.target.click();
}
});
window.addEventListener('click', function (e) {
var b = e.target && e.target.closest ? e.target.closest('button[name="add"], button[type="submit"]') : null;
if (!b || !form.contains(b) || nav.contains(b)) return;
if (!guard(e)) return;
var all = bikeData() || {}, dz = designData() || {}; for (var k in dz) all[k] = dz[k]; all.total = totalText(); track('efp_add_to_cart', all);
setTimeout(checkZeptoError, 150);
}, true);
window.addEventListener('submit', function (e) {
if (e.target !== form) return;
if (current < 3) { e.preventDefault(); e.stopImmediatePropagation(); requestStep(current + 1); return; }
guard(e);
}, true);
}
function guard(e) {
for (var k = 1; k <= 3; k++) {
var miss = missingIn(k);
if (miss.length) {
e.preventDefault(); e.stopImmediatePropagation();
if (k !== current) go(k, true);
setMsg(miss); miss[0].focus();
return false;
}
}
return true;
}
function checkZeptoError() {
var r = root.querySelector('.pplr_red_wrapper');
if (!r) return;
var w = r.classList.contains('pplr-wrapper') ? r : r.closest('.pplr-wrapper');
if (!w) return;
if (stepOf(w) !== current) go(stepOf(w), true);
if (bike && stepOf(w) === 1) { var bm = stepOneMissing(); setMsg(bm.length ? bm : [{ label: HELMET ? 'Your helmet' : 'Your bike', node: bike, focus: function () {} }], HELMET ? 'Please choose your helmet model again.' : 'Please check your bike details and choose them again.'); return; }
setMsg([item(w)]);
}

/* ---------- Step 1: structured bike selector ---------- */
function zWrap(prefix) {
var all = root.querySelectorAll('.pplr-wrapper');
for (var i = 0; i < all.length; i++) if (!zeptoHidden(all[i]) && hasPrefix(all[i], [prefix])) return all[i];
return null;
}
function zCatSwatches() { var w = zWrap('pplr-category'); return w ? Array.prototype.slice.call(w.querySelectorAll('.pplr-swatch-element')) : []; }
function zBrandSelect() { var w = zWrap('pplr-brand'); return w ? w.querySelector('select.pplr_select') : null; }
function zModelInput() { var w = zWrap('pplr-model'); return w ? w.querySelector('input.pplr_text, textarea.pplr_text') : null; }
function zYearSelect() { var w = zWrap('pplr-year'); return w ? w.querySelector('select.pplr_select') : null; }
function zYears() {
var s = zYearSelect(), out = {};
if (s) Array.prototype.forEach.call(s.options, function (o) { if (/^\d{4}$/.test(o.value)) out[o.value] = true; });
return out;
}
function fire(node, types) { types.forEach(function (t) { node.dispatchEvent(new Event(t, { bubbles: true })); }); }
function setSelect(s, want) {
if (!s) return false;
var val = '';
if (want) {
var low = String(want).toLowerCase();
for (var i = 0; i < s.options.length; i++) if (s.options[i].value.toLowerCase() === low) { val = s.options[i].value; break; }
if (!val) return false;
}
if (s.value !== val) { s.value = val; fire(s, ['change']); }
return s.value === val;
}
function setText(inp, val) {
if (!inp) return false;
if (inp.value !== val) {
var proto = inp.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
Object.getOwnPropertyDescriptor(proto, 'value').set.call(inp, val);
fire(inp, ['input', 'change']);
}
return inp.value === val;
}
/* Zepto's own "Other brand" option of the brand list that is on the page now ('' when it has none). */
function otherBrandValue() {
var s = zBrandSelect();
if (s) for (var i = 0; i < s.options.length; i++) if (/^other\b/i.test(s.options[i].value)) return s.options[i].value;
return '';
}
/* The catalog key for a Zepto category name: exact, or through the catalog's list of other spellings, so a
product may call its category "Adventure & Touring", "E-bike" or "Street bike". */
function catOf(v) {
if (!v || !CAT || !CAT.c) return '';
if (CAT.c[v]) return v;
var k = CAT.a && CAT.a[norm(v)];
return k && CAT.c[k] ? k : '';
}
function catData() { var k = catOf(sel.cat); return k ? CAT.c[k] : null; }
/* Brands in Zepto's own list for this category (without the placeholder and its "Other" option). */
function zBrandNames() {
var s = zBrandSelect(), out = [];
if (s) for (var i = 0; i < s.options.length; i++) { var v = s.options[i].value; if (v && !/^other\b/i.test(v)) out.push(v); }
return out;
}
/* The brands offered: every catalog brand of the category, plus every brand of Zepto's list that has no catalog
models (those can only be typed in as "Other"). */
function brandList() {
var c = catData();
if (!c) return [];
var out = Object.keys(c), low = out.map(function (b) { return b.toLowerCase(); });
zBrandNames().forEach(function (z) { var hit = false; for (var k in c) if (String(c[k].z).toLowerCase() === z.toLowerCase()) hit = true; if (!hit && low.indexOf(z.toLowerCase()) < 0) { out.push(z); low.push(z.toLowerCase()); } });
return out.sort(function (a, b) { return a.localeCompare(b); });
}
function brandData() {
var c = catData();
if (!sel.cat || !sel.brand || !c) return null;
if (sel.brand === OTHER_BRAND) return { z: otherBrandValue(), m: [], other: true };
if (c[sel.brand]) return c[sel.brand];
return brandList().indexOf(sel.brand) > -1 ? { z: sel.brand, m: [] } : null;
}
/* Zepto's option for a catalog brand; a brand that is not (yet) in Zepto's list goes in as its "Other" option,
with the brand name kept in the model text. */
function zBrandFor(b) {
if (!b) return '';
if (b.other) return b.z;
var s = zBrandSelect(), low = String(b.z).toLowerCase();
if (s) for (var i = 0; i < s.options.length; i++) if (s.options[i].value.toLowerCase() === low) return s.options[i].value;
return otherBrandValue() || b.z;
}
function modelData() {
var b = brandData();
if (!b) return null;
if (sel.model === OTHER) return { n: String(sel.other).replace(/\s+/g, ' ').trim(), g: [], other: true };
return sel.model > -1 ? b.m[sel.model] || null : null;
}
/* Years offered for a model: the years of its templates that Zepto's own year list knows. A model without
such a year (no confirmed template, or only years Zepto does not list) and a typed "Other" model get every
year of Zepto's list; the order then carries _Template CHECK or OTHER instead of a template reference. */
function yearsFor(m) {
var ok = zYears(), out = [];
if (!m) return out;
m.g.forEach(function (g) { for (var y = g[0]; y <= g[1]; y++) if (ok[y] && out.indexOf(y) < 0) out.push(y); });
if (!out.length) out = Object.keys(ok).map(Number);
return out.sort(function (a, b) { return b - a; });
}
function refsFor(m, year) {
var out = [];
if (m && year) m.g.forEach(function (g) { if (+year >= g[0] && +year <= g[1]) { var r = typeof g[2] === 'string' ? g[2] : 'TM-R' + g[2]; if (out.indexOf(r) < 0) out.push(r); } });
return out.join(' | ');
}
/* What Zepto's own fields must contain for the current selection. */
/* Price tier of the chosen model: the cheapest template that fits the chosen year; a model without a confirmed
template takes its own tier, a typed model the most common tier of its category. */
function tierFor(m, year) {
if (!m) return 0;
var t = null;
if (!m.other && year) m.g.forEach(function (g) { if (+year >= g[0] && +year <= g[1] && g[3] != null) t = t == null ? g[3] : Math.min(t, g[3]); });
if (t == null && !m.other && m.t != null) t = m.t;
if (t == null) { var k = catOf(sel.cat); t = k && CAT.d && CAT.d[k] != null ? CAT.d[k] : 0; }
return t;
}
function desired() {
var b = brandData(), m = modelData(), ys = yearsFor(m), name = m ? m.n : '';
var complete = !!(b && name && ys.length && sel.year && ys.indexOf(+sel.year) > -1);
var zb = zBrandFor(b);
/* A brand that Zepto only knows as "Other brand" keeps its name in the model text. */
var model = name ? (!b.other && /^other\b/i.test(zb) ? sel.brand + ' ' + name : name) : '';
var ref = complete ? (m.other ? 'OTHER' : refsFor(m, sel.year) || 'CHECK') : '';
return { cat: sel.cat, brand: b ? zb : '', model: model, year: complete ? String(sel.year) : '', ref: ref, complete: complete,
tier: complete ? tierFor(m, sel.year) : 0, race: !!(m && m.k) };
}
/* ---------- Hidden price fields ---------- */
function zFee(prefix) { var w = zWrap(prefix); return w ? w.querySelector('select.pplr_select, select') : null; }
function feeOptions(s) { var out = []; if (s) for (var i = 0; i < s.options.length; i++) if (s.options[i].value) out.push(s.options[i]); return out; }
function tierValue(s, tier) {
var opts = feeOptions(s), want = (TIER_NAMES[tier] || '').toLowerCase();
for (var i = 0; i < opts.length; i++) if (opts[i].value.toLowerCase() === want) return opts[i].value;
return opts[tier] ? opts[tier].value : (opts[0] ? opts[0].value : '');
}
function typeValue(s, race) {
var opts = feeOptions(s), re = race ? /race|sport/i : /naked|roadster/i;
for (var i = 0; i < opts.length; i++) if (re.test(opts[i].value)) return opts[i].value;
return opts[race ? 1 : 0] ? opts[race ? 1 : 0].value : '';
}
function feeWanted() {
var d = desired(), t = zFee(FEE.tpl), y = zFee(FEE.type);
return { tpl: t ? tierValue(t, d.tier) : null, type: y ? typeValue(y, d.race) : null };
}
function pushFees() {
var f = feeWanted(), ok = true;
if (f.tpl != null) ok = setSelect(zFee(FEE.tpl), f.tpl) && ok;
if (f.type != null) ok = setSelect(zFee(FEE.type), f.type) && ok;
return ok;
}
function feesInSync() {
var f = feeWanted(), t = zFee(FEE.tpl), y = zFee(FEE.type);
return (f.tpl == null || t.value === f.tpl) && (f.type == null || y.value === f.type);
}
/* The amount Zepto shows for an option, when its text carries one ("Level 1 (+€20.00)"). */
function feeAmount(s) {
if (!s || !s.value) return '';
var o = s.options[s.selectedIndex], txt = o ? o.textContent : '';
var m = txt.match(/(?:€|EUR)\s?\d[\d.,]*|\d[\d.,]*\s?(?:€|EUR)/i);
return m ? m[0].replace(/\s+/g, ' ') : '';
}
function renderFees() {
if (!feeNote) return;
var d = desired(), parts = [], t = zFee(FEE.tpl), y = zFee(FEE.type);
if (d.complete && t && d.tier > 0) { var a = feeAmount(t); parts.push('the template for your exact model' + (a ? ' (' + a + ')' : '')); }
if (d.complete && y && d.race) { var b = feeAmount(y); parts.push('the extra panels of a full fairing' + (b ? ' (' + b + ')' : '')); }
feeNote.hidden = !parts.length;
feeNote.textContent = parts.length ? 'The price includes ' + parts.join(' and ') + '.' : '';
}
function pushToZepto() {
var d = desired(), ok = true;
if (d.cat) {
var sw = zCatSwatches().filter(function (s) { return s.getAttribute('data-val') === d.cat; })[0];
if (!sw) ok = false; else if (!sw.classList.contains('selected')) sw.click();
}
ok = setSelect(zBrandSelect(), d.brand) && ok;
ok = setText(zModelInput(), d.model) && ok;
ok = setSelect(zYearSelect(), d.year) && ok;
ok = pushFees() && ok;
if (refInput) { refInput.value = d.ref; refInput.disabled = !d.ref; }
return ok;
}
function inSync() {
var d = desired(), c = zWrap('pplr-category'), ci = c && c.querySelector('input[name="properties[Category]"]');
var b = zBrandSelect(), m = zModelInput(), y = zYearSelect();
return !!(ci && b && m && y && ci.value === d.cat && b.value === d.brand && m.value === d.model && y.value === d.year) && feesInSync();
}
var pushTimers = [];
function commit() {
pushTimers.forEach(clearTimeout); pushTimers = [];
pushToZepto();
/* Zepto swaps the brand field when the category changes, so repeat until its fields have settled. */
[250, 700, 1500].forEach(function (t) { pushTimers.push(setTimeout(function () { if (!inSync()) pushToZepto(); renderBike(); }, t)); });
renderBike();
onChange();
}
function bikeMissing() {
var out = [], b = brandData(), m = modelData();
var f = function (label, key, text) { return { label: label, node: key === 'cat' ? bike.querySelector('.efp-field--cat') : key === 'other' ? otherField : combos[key].el, text: text, focus: function () { (key === 'cat' ? catBtns[0] : key === 'other' ? otherInput : combos[key].btn).focus(); } }; };
if (!sel.cat) out.push(f('Category', 'cat'));
if (!b) out.push(f('Brand', 'brand'));
if (!m) out.push(f('Model', 'model'));
else if (m.other && !m.n) out.push(f(otherLabel.textContent, 'other'));
if (!sel.year) out.push(f('Year', 'year'));
if (!out.length && !inSync()) { pushToZepto(); if (!inSync()) out.push({ label: 'Your bike', node: bike, text: 'We could not save your bike selection. Please choose your model and year again.', focus: function () { combos.model.btn.focus(); } }); }
return out;
}
function norm(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
function closeCombos(except) { Object.keys(combos).forEach(function (k) { if (combos[k] !== except) combos[k].close(); }); }
function Combo(key, label, placeholder) {
var c = { key: key, options: [], active: -1 };
var id = 'efp-combo-' + key;
c.el = el('div', 'efp-field efp-combo');
c.el.innerHTML = '<span class="efp-field__label" id="' + id + '-l">' + label + '</span>' +
'<button type="button" class="efp-combo__btn" id="' + id + '-b" aria-haspopup="listbox" aria-expanded="false" aria-controls="' + id + '-p" aria-labelledby="' + id + '-l ' + id + '-b" disabled><span class="efp-combo__val is-placeholder"></span></button>' +
'<div class="efp-combo__panel" id="' + id + '-p" hidden><input class="efp-combo__search" type="text" inputmode="search" autocomplete="off" autocapitalize="off" spellcheck="false" aria-label="Search ' + label.toLowerCase() + '" placeholder="Search…"><ul class="efp-combo__list" role="listbox" tabindex="-1" aria-labelledby="' + id + '-l"></ul></div>';
c.btn = c.el.querySelector('.efp-combo__btn'); c.val = c.el.querySelector('.efp-combo__val');
c.panel = c.el.querySelector('.efp-combo__panel'); c.search = c.el.querySelector('.efp-combo__search'); c.list = c.el.querySelector('.efp-combo__list');
c.placeholder = placeholder;
c.shown = function () { return Array.prototype.slice.call(c.list.querySelectorAll('[role=option]')); };
c.render = function () {
var q = norm(c.search.value).split(' ').filter(Boolean), html = '', n = 0, real = 0;
c.options.forEach(function (o, i) {
var hay = norm(o.t);
if (!o.always) { for (var k = 0; k < q.length; k++) if (hay.indexOf(q[k]) < 0) return; real++; }
html += '<li role="option"' + (o.always ? ' class="efp-combo__other"' : '') + ' id="' + id + '-o' + i + '" data-i="' + i + '" aria-selected="' + (o.v === c.value ? 'true' : 'false') + '"><span>' + esc(o.t) + '</span></li>';
n++;
});
c.list.innerHTML = (q.length && !real ? '<li class="efp-combo__empty">No match' + (n ? '. Choose the last option and type it in.' : '.') + '</li>' : '') + html;
c.setActive(n ? 0 : -1, true);
};
c.setActive = function (i, quiet) {
var items = c.shown();
c.active = items.length ? Math.max(0, Math.min(items.length - 1, i)) : -1;
items.forEach(function (li, k) { li.classList.toggle('is-active', k === c.active); });
var a = items[c.active];
(c.search.hidden ? c.list : c.search).setAttribute('aria-activedescendant', a ? a.id : '');
if (a && !quiet) a.scrollIntoView({ block: 'nearest' });
};
c.open = function () {
if (c.btn.disabled || !c.panel.hidden) return;
closeCombos(c);
c.search.value = ''; c.search.hidden = c.options.length < 8;
c.panel.hidden = false; c.btn.setAttribute('aria-expanded', 'true'); c.el.classList.add('is-open');
c.render();
var cur = c.list.querySelector('[aria-selected=true]');
if (cur) { c.setActive(c.shown().indexOf(cur), true); c.list.scrollTop = Math.max(0, cur.offsetTop - 80); }
if (c.search.hidden) c.list.focus({ preventScroll: true }); else if (finePointer) c.search.focus({ preventScroll: true });
var r = c.el.getBoundingClientRect();
if (r.bottom > window.innerHeight - 8) window.scrollBy({ top: Math.min(r.bottom - window.innerHeight + 16, r.top - 90), behavior: reduceMotion ? 'auto' : 'smooth' });
};
c.close = function (refocus) {
if (c.panel.hidden) return;
c.panel.hidden = true; c.btn.setAttribute('aria-expanded', 'false'); c.el.classList.remove('is-open');
if (refocus) c.btn.focus({ preventScroll: true });
};
c.set = function (options, value, enabled) {
c.options = options; c.value = value;
var cur = options.filter(function (o) { return o.v === value; })[0];
c.val.textContent = cur ? cur.t : c.placeholder;
c.val.classList.toggle('is-placeholder', !cur);
c.btn.disabled = !enabled;
c.el.classList.toggle('is-disabled', !enabled);
c.el.classList.toggle('is-set', !!cur);
if (!enabled) c.close();
};
c.pick = function (li) { if (!li || !li.hasAttribute('data-i')) return; var o = c.options[+li.getAttribute('data-i')]; c.close(true); choose(key, o.v); };
c.btn.addEventListener('click', function () { if (c.panel.hidden) c.open(); else c.close(); });
c.btn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); c.open(); } });
c.search.addEventListener('input', c.render);
c.list.addEventListener('click', function (e) { c.pick(e.target.closest('[role=option]')); });
c.panel.addEventListener('keydown', function (e) {
if (e.key === 'ArrowDown') { e.preventDefault(); c.setActive(c.active + 1); }
else if (e.key === 'ArrowUp') { e.preventDefault(); c.setActive(c.active - 1); }
else if (e.key === 'Home' && e.target === c.list) { e.preventDefault(); c.setActive(0); }
else if (e.key === 'End' && e.target === c.list) { e.preventDefault(); c.setActive(1e4); }
else if (e.key === 'Enter') { e.preventDefault(); c.pick(c.shown()[c.active]); }
else if (e.key === 'Escape') { e.preventDefault(); c.close(true); }
else if (e.key === 'Tab') c.close();
});
return c;
}
function choose(key, v) {
if (key === 'cat') { if (sel.cat === v) return; sel = { cat: v, brand: '', model: -1, year: '', other: '' }; }
else if (key === 'brand') { if (sel.brand === v) return; sel.brand = v; sel.model = v === OTHER_BRAND ? OTHER : -1; sel.year = ''; sel.other = ''; var bd = brandData(); if (bd && !bd.other && !bd.m.length) sel.model = OTHER; }
else if (key === 'model') { if (sel.model === v) return; sel.model = v; sel.year = ''; sel.other = ''; }
else if (key === 'year') sel.year = v;
commit();
var typed = sel.model === OTHER;
var next = key === 'cat' ? 'brand' : key === 'brand' ? (typed ? 'other' : 'model') : key === 'model' ? (typed ? 'other' : 'year') : null;
if (next === 'other') setTimeout(function () { otherInput.focus(); }, 60);
else if (next) setTimeout(function () { combos[next].open(); }, 60);
}
function renderBike() {
catBtns.forEach(function (b) { b.setAttribute('aria-checked', b.dataset.val === sel.cat ? 'true' : 'false'); });
var cv = bike.querySelector('.efp-field--cat .efp-field__value');
cv.textContent = sel.cat || 'Choose your category';
cv.classList.toggle('is-placeholder', !sel.cat);
var brands = brandList();
var bo = brands.map(function (b) { return { v: b, t: b }; });
if (brands.length && otherBrandValue()) bo.push({ v: OTHER_BRAND, t: 'Other brand', always: true });
combos.brand.set(bo, sel.brand, brands.length > 0);
var b = brandData(), mo = [];
if (b) {
b.m.forEach(function (m, i) { if (!HIDE_MODEL.test(m.n)) mo.push({ v: i, t: m.n }); });
mo.push({ v: OTHER, t: 'Other (type your model)', always: true });
}
combos.model.set(mo, sel.model, !!b && !b.other);
var m = modelData(), ys = yearsFor(m);
combos.year.set(ys.map(function (y) { return { v: String(y), t: String(y) }; }), String(sel.year), ys.length > 0);
var typed = !!(m && m.other), both = sel.brand === OTHER_BRAND;
otherField.hidden = !typed;
otherLabel.textContent = both ? 'Your brand and model' : 'Your model';
otherInput.placeholder = both ? 'For example: Stark Varg MX' : 'For example: RR 300 Racing';
if (typed && otherInput.value !== sel.other) otherInput.value = sel.other;
renderFees();
}
/* A typed model is also reported as an analytics event, so demand for bikes that are not listed shows up
even when no order follows. It goes through Shopify's own customer-events channel (and gtag when present),
which apply the visitor's consent. */
var lastTracked = '';
function trackOther() {
var m = modelData();
if (!m || !m.other || !m.n) return;
var data = { category: sel.cat, brand: sel.brand === OTHER_BRAND ? 'Other brand' : sel.brand, model: m.n.slice(0, 60) };
var key = data.category + '|' + data.brand + '|' + data.model.toLowerCase();
if (key === lastTracked) return;
lastTracked = key;
track('efp_other_model', data);
}
/* ---------- Market research ----------
Every choice is reported as an event: efp_bike (the bike, when the customer continues to step 2), efp_design (the
design choices, on reaching step 3), efp_add_to_cart (everything, with the total), efp_other_model (a typed model)
and efp_category_switch (a click to another category's configurator). They go to Shopify's customer events
(Shopify.analytics.publish, readable by a custom pixel), to gtag when it is on the page, and to Microsoft Clarity
as custom tags (efp_category, efp_brand, efp_model, ...) plus an event, so sessions can be filtered on them in
Clarity. All three apply the visitor's consent. The same event with the same data is sent once per page view. */
var sent = {};
function track(name, data) {
if (!data) return;
var key = name + '|' + JSON.stringify(data);
if (sent[key]) return;
sent[key] = true;
data.product = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (err) {}
try { if (typeof window.gtag === 'function') { var g = {}; for (var k in data) g['efp_' + k] = data[k]; window.gtag('event', name, g); } } catch (err) {}
try { if (typeof window.clarity === 'function') { for (var t in data) if (data[t] !== '' && data[t] != null) window.clarity('set', 'efp_' + t, String(data[t]).slice(0, 100)); window.clarity('event', name); } } catch (err) {}
}
function bikeData() {
if (!bike) return null;
if (HELMET) return sel.cat ? { category: 'Helmet', brand: '', model: sel.cat, year: '', listed: 'yes' } : null;
var d = desired(), m = modelData();
if (!d.complete) return null;
return { category: sel.cat, brand: sel.brand === OTHER_BRAND ? 'Other brand' : sel.brand, model: m ? m.n.slice(0, 60) : '', year: d.year, listed: m && !m.other ? 'yes' : 'no' };
}
/* The step 2 choices as { design: 'Design 1', design_color: 'Green', ... }. */
function designData() {
var out = {}, n = 0;
wrappers(2).forEach(function (w) {
var v = valueOf(w), k = norm(labelOf(w)).replace(/ /g, '_');
if (v && k && !(k in out) && n < 10) { out[k] = v.text.slice(0, 60); n++; }
});
return n ? out : null;
}
/* The price fields stay in Zepto's form (Zepto prices them and puts them in the order) but are not shown:
visually hidden, not display:none, because Zepto decides with :visible which fields count. */
function hideFeeFields() {
if (!document.getElementById('efp-fee-css')) { var st = document.createElement('style'); st.id = 'efp-fee-css'; st.textContent = '.efp-fee-field{position:absolute!important;left:0!important;top:0!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;white-space:nowrap!important;margin:0!important;padding:0!important;border:0!important}'; document.head.appendChild(st); }
root.querySelectorAll('.pplr-wrapper').forEach(function (w) { if (isFee(w) && !w.classList.contains('efp-fee-field')) { w.classList.add('efp-fee-field'); w.setAttribute('aria-hidden', 'true'); w.querySelectorAll('select,input').forEach(function (i) { i.tabIndex = -1; }); } });
}
/* The categories this product sells, from the current link of the intro's category choice (data-cats,
"Moto 50cc|Motocross"). Empty when the page has no category choice: then every category of Zepto's field stays. */
function ownCats() {
var a = document.querySelector('.efp-catnav [aria-current="page"][data-cats]');
return a ? a.getAttribute('data-cats').split('|').map(catOf).filter(Boolean) : [];
}
function bindCatnav() {
document.querySelectorAll('.efp-catnav a[data-cats]:not([aria-current])').forEach(function (a) {
a.addEventListener('click', function () { var cur = document.querySelector('.efp-catnav [aria-current="page"]'); track('efp_category_switch', { from: cur ? cur.textContent.trim() : '', to: a.textContent.trim() }); });
});
}
function cfgAttr(name, fallback) { var i = document.querySelector('.efp-intro'); return (i && i.getAttribute('data-' + name)) || fallback; }
function buildBike() {
var sw = zCatSwatches(), cats = [];
sw.forEach(function (s) { var v = s.getAttribute('data-val'); if (v && catOf(v)) cats.push({ v: v, img: s.getAttribute('data-image') || '' }); });
var own = ownCats(), mine = cats.filter(function (c) { return own.indexOf(catOf(c.v)) > -1; });
if (mine.length) cats = mine;
if (!cats.length || !zBrandSelect() || !zModelInput() || !zYearSelect()) return false;
bike = el('div', 'efp-bike'); bike.id = 'efp-bike';
var cf = el('div', 'efp-field efp-field--cat');
cf.innerHTML = '<span class="efp-field__label" id="efp-cat-l">Category <span class="efp-field__value is-placeholder">Choose your category</span></span><div class="efp-cats" role="radiogroup" aria-labelledby="efp-cat-l"></div>';
var group = cf.querySelector('.efp-cats');
cats.forEach(function (c) {
var b = el('button', 'efp-cat', (c.img ? '<img src="' + esc(c.img) + (c.img.indexOf('?') < 0 ? '?width=320' : '') + '" alt="" loading="lazy" width="160" height="110">' : '') + '<span>' + esc(c.v) + '</span>');
b.type = 'button'; b.dataset.val = c.v; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
b.addEventListener('click', function () { choose('cat', c.v); });
group.appendChild(b); catBtns.push(b);
});
group.addEventListener('keydown', function (e) {
var i = catBtns.indexOf(document.activeElement); if (i < 0) return;
if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); catBtns[(i + 1) % catBtns.length].focus(); }
if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); catBtns[(i - 1 + catBtns.length) % catBtns.length].focus(); }
});
bike.appendChild(cf);
combos.brand = Combo('brand', 'Brand', 'Choose your brand');
combos.model = Combo('model', 'Model', 'Choose your model');
combos.year = Combo('year', 'Year', 'Choose your year');
otherField = el('div', 'efp-field efp-other');
otherField.innerHTML = '<label class="efp-field__label" for="efp-other-i">Your model</label><input class="efp-other__input" id="efp-other-i" type="text" maxlength="60" autocomplete="off" autocapitalize="words" spellcheck="false"><p class="efp-other__note">Type the exact model, so we make the kit for the right bike.</p>';
otherField.hidden = true;
otherLabel = otherField.querySelector('label'); otherInput = otherField.querySelector('input');
var typing = null;
otherInput.addEventListener('input', function () { sel.other = otherInput.value; clearTimeout(typing); typing = setTimeout(commit, 350); });
otherInput.addEventListener('change', function () { sel.other = otherInput.value; clearTimeout(typing); commit(); trackOther(); });
otherInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); otherInput.blur(); if (!sel.year) combos.year.open(); } });
bike.appendChild(combos.brand.el); bike.appendChild(combos.model.el); bike.appendChild(otherField); bike.appendChild(combos.year.el);
feeNote = el('p', 'efp-bike__fees'); feeNote.hidden = true; feeNote.setAttribute('aria-live', 'polite');
feeNote.style.cssText = 'margin:2px 0 0;font-size:13px;line-height:1.45;color:#6b6b72';
bike.appendChild(feeNote);
bike.appendChild(el('p', 'efp-bike__hint', 'Can&rsquo;t find your bike? Choose <strong>Other</strong> at the bottom of the brand or model list and type it in.'));
/* A product with one category: that choice is made already. */
if (cats.length === 1) { cf.hidden = true; sel.cat = cats[0].v; }
hideFeeFields();
root.parentNode.insertBefore(bike, root);
refInput = el('input'); refInput.type = 'hidden'; refInput.name = REF_NAME; refInput.disabled = true;
form.appendChild(refInput);
document.addEventListener('pointerdown', function (e) { if (!e.target.closest || !e.target.closest('.efp-combo')) closeCombos(); });
document.body.classList.add('efp-bike-on');
return true;
}
function stepOneMissing() { return HELMET ? helmetMissing() : bikeMissing(); }

/* ---------- Step 1 in helmet mode: only the helmet model ----------
A helmet product carries the Zepto setup of the bike products (Category, Brand, Model Name, Year). Only Model Name
is used: it gets the chosen helmet model. The other bike fields are hidden like on every configurator page, and their
"required" mark is taken off on this page only, so they do not block "Add to cart" for a helmet. Nothing is changed in
Zepto; once those fields are removed from the helmet product in the Zepto app, this has nothing left to do. The model
buttons use the same markup as the category cards, so efp-configurator-keep.js puts the choice back after a reload. */
function helmetConfig() {
if (cfgAttr('mode', '') !== 'helmet') return null;
var models = cfgAttr('models', '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
return models.length ? { models: models } : null;
}
var BIKE_ONLY = ['pplr-category', 'pplr-brand', 'pplr-year', 'pplr-vehicle', 'pplr-bike'];
function relaxBikeFields() {
root.querySelectorAll('.pplr-wrapper').forEach(function (w) {
if (!hasPrefix(w, BIKE_ONLY)) return;
w.querySelectorAll('[required], .cstmfy_c_required').forEach(function (i) { i.removeAttribute('required'); i.classList.remove('cstmfy_c_required'); i.setAttribute('data-efp-optional', '1'); });
w.classList.remove('pplr_red_wrapper');
});
}
function helmetInSync() { var m = zModelInput(); return !!(m && m.value === sel.cat); }
function pushHelmet() {
var ok = setText(zModelInput(), sel.cat);
/* Zepto's own sample values (brand Derbi, year 2000) would otherwise go along with a helmet order. */
setSelect(zBrandSelect(), '');
setSelect(zYearSelect(), '');
relaxBikeFields();
return ok;
}
function helmetMissing() {
if (!sel.cat) return [{ label: 'Helmet model', node: helmetField, focus: function () { if (catBtns[0]) catBtns[0].focus(); } }];
if (!helmetInSync() && !(pushHelmet() && helmetInSync())) return [{ label: 'Your helmet', node: bike, text: 'We could not save your helmet model. Please choose it again.', focus: function () { if (catBtns[0]) catBtns[0].focus(); } }];
return [];
}
function buildHelmet() {
if (!zModelInput()) return false;
bike = el('div', 'efp-bike efp-bike--helmet'); bike.id = 'efp-bike';
helmetField = el('div', 'efp-field efp-field--cat');
helmetField.innerHTML = '<span class="efp-field__label" id="efp-cat-l">Helmet model <span class="efp-field__value is-placeholder">Choose your helmet</span></span><div class="efp-cats" role="radiogroup" aria-labelledby="efp-cat-l"></div>';
var group = helmetField.querySelector('.efp-cats');
var render = function () {
catBtns.forEach(function (b) { b.setAttribute('aria-checked', b.dataset.val === sel.cat ? 'true' : 'false'); });
var v = helmetField.querySelector('.efp-field__value');
v.textContent = sel.cat || 'Choose your helmet';
v.classList.toggle('is-placeholder', !sel.cat);
};
HELMET.models.forEach(function (m) {
var b = el('button', 'efp-cat', '<span>' + esc(m) + '</span>');
b.type = 'button'; b.dataset.val = m; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
b.addEventListener('click', function () { sel.cat = m; pushHelmet(); [250, 700, 1500].forEach(function (t) { setTimeout(function () { if (!helmetInSync()) pushHelmet(); }, t); }); render(); onChange(); });
group.appendChild(b); catBtns.push(b);
});
group.addEventListener('keydown', function (e) {
var i = catBtns.indexOf(document.activeElement); if (i < 0) return;
if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); catBtns[(i + 1) % catBtns.length].focus(); }
if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); catBtns[(i - 1 + catBtns.length) % catBtns.length].focus(); }
});
bike.appendChild(helmetField);
bike.appendChild(el('p', 'efp-bike__hint', 'The kit is cut for the exact shape of this helmet model.'));
root.parentNode.insertBefore(bike, root);
/* Start empty: the model text Zepto may carry from its own setup is not the customer's choice. */
setText(zModelInput(), '');
pushHelmet();
render();
document.body.classList.add('efp-bike-on');
return true;
}

/* ---------- Linked copies must have the options of their original ----------
Zepto links same-named image fields across views and, on a choice in the original, selects the option with the same
name in the copy. When the copy's image group has none of those options (seen 2026-10-15 on Moto 50cc / MX: "Textures"
in View 2D points to a group "Textures 2D" that does not exist, so the copy has no options at all), the copy keeps its
start image (there the "Extra Details" artwork, 1246-2D.png) and the 2D view never shows the chosen texture. Such an
empty copy gets a copy of its original's options, on this page only; the option that is preselected in the original
keeps the copy's own start image. Nothing is saved in Zepto; once the copy has its own options this does nothing. */
function fixLinkedImageGroups() {
var vals = window.pplr_values;
if (!vals || !root) return 0;
var fixed = 0, byName = {};
root.querySelectorAll('.pplr-wrapper[data-main][data-pview]').forEach(function (w) {
var v = vals[w.getAttribute('data-main')];
if (!v || v.length < 93) return;
var name = String(v[8]).trim().toLowerCase();
(byName[name] = byName[name] || []).push(w);
});
Object.keys(byName).forEach(function (name) {
var list = byName[name];
if (list.length < 2) return;
var src = list.filter(function (w) { return w.querySelector('.pplr-swatch-main > .pplr-swatch-element'); })[0];
if (!src) return;
list.forEach(function (w) {
if (w === src || w.getAttribute('data-pview') === src.getAttribute('data-pview') || w.hasAttribute('data-efp-options')) return;
var box = w.querySelector('.pplr-swatch-main');
if (!box || box.querySelector('.pplr-swatch-element')) return;
var frame = w.getAttribute('data-main'), own = w.querySelector('img.img_url'), ownSrc = own ? own.getAttribute('data-psrc') : '';
var start = src.querySelector('input.pplr_imgg'), startVal = start ? start.value : '';
src.querySelectorAll('.pplr-swatch-main > .pplr-swatch-element').forEach(function (s) {
var c = s.cloneNode(true);
c.setAttribute('data-frame', frame);
c.classList.remove('selected');
c.setAttribute('aria-pressed', 'false');
if (ownSrc && c.getAttribute('data-val') === startVal) c.setAttribute('data-image', ownSrc);
box.appendChild(c);
});
w.setAttribute('data-efp-options', 'copied');
fixed++;
});
});
return fixed;
}
function watchLinkedImageGroups(tries) {
tries = tries || 0;
var done = 0;
try { done = fixLinkedImageGroups(); } catch (err) { if (window.console) console.warn('EFP linked-options check skipped', err); return; }
if (!done && tries < 40) setTimeout(function () { watchLinkedImageGroups(tries + 1); }, 250);
}

/* ---------- Preview: compact view switch inside the image ---------- */
function viewMeta(name) {
for (var i = 0; i < VIEWS.length; i++) if (VIEWS[i][0].test(name)) return VIEWS[i];
return [null, name, 'bike'];
}
function buildViewSwitch(tries) {
tries = tries || 0;
var views = window.pplr_views, media = document.querySelector('.hdt-product__media.pplr');
if (!views || !media || !document.querySelector('.pplr_arrow_right')) {
if (tries < 60) setTimeout(function () { buildViewSwitch(tries + 1); }, 250);
return;
}
var ids = Object.keys(views);
if (ids.length < 2 || document.querySelector('.efp-vs')) return;
var sw = el('div', 'efp-vs'); sw.setAttribute('role', 'group'); sw.setAttribute('aria-label', 'Preview view');
sw.style.setProperty('--efp-vs-n', ids.length);
ids.forEach(function (id) {
var meta = viewMeta(String(views[id][4] || 'View'));
var b = el('button', 'efp-vs__btn', '<i class="efp-vs__ico efp-vs__ico--' + meta[2] + '" aria-hidden="true"></i>');
b.type = 'button'; b.dataset.view = id; b.setAttribute('aria-label', meta[1] + ' view'); b.title = meta[1];
b.addEventListener('click', function () { setView(id); });
sw.appendChild(b);
});
/* Keep every pointer event inside the switch: the theme opens its zoom lightbox on media clicks. */
['click', 'mousedown', 'mouseup', 'pointerdown', 'pointerup', 'touchstart', 'touchend', 'dblclick'].forEach(function (t) {
sw.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: true });
});
var host = media.closest('.hdt-product-media__main') || media.parentNode;
if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
host.appendChild(sw);
document.body.classList.add('efp-vs-on');
syncView();
media.addEventListener('click', function () { setTimeout(syncView, 450); });
}
function markView(id) {
var ids = Object.keys(window.pplr_views || {});
var sw = document.querySelector('.efp-vs'); if (!sw) return;
sw.style.setProperty('--efp-vs-i', Math.max(0, ids.indexOf(id)));
sw.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.view === id ? 'true' : 'false'); });
}
function syncView() { markView(window.pplr_current_view); }
function setView(id) {
var ids = Object.keys(window.pplr_views || {});
var from = ids.indexOf(window.pplr_current_view), to = ids.indexOf(id);
if (to < 0 || from === to) { syncView(); return; }
var arrow = document.querySelector(to > from ? '.pplr_arrow_right' : '.pplr_arrow_left');
var times = Math.abs(to - from);
(function step(left) {
if (!arrow || left <= 0) { setTimeout(syncView, 450); return; }
if (typeof window.pplr_view_to_arrow === 'function') window.pplr_view_to_arrow(arrow); else arrow.click();
setTimeout(function () { step(left - 1); }, 420);
})(times);
markView(id);
}

/* ---------- Intro: "Start customizing" + optional instalment amount ---------- */
function bindIntro() {
document.addEventListener('click', function (e) {
var a = e.target.closest ? e.target.closest('[data-efp-start]') : null;
if (!a || !head) return;
e.preventDefault();
go(1, true, true);
});
var out = document.querySelector('[data-efp-instalment]'), p = priceEl();
if (!out || !p) return;
var parts = parseInt(out.getAttribute('data-efp-instalment'), 10) || 0;
var update = function () {
var txt = p.textContent, m = txt.match(/\d[\d.,]*/);
if (!m || parts < 2) return;
var raw = m[0], dec = /[.,]\d{2}$/.test(raw) ? raw.charAt(raw.length - 3) : '';
var num = parseFloat(raw.replace(dec === ',' ? /\./g : /,/g, '').replace(',', '.'));
if (!isFinite(num)) return;
var each = (Math.ceil(num * 100 / parts) / 100).toFixed(2).replace('.', dec || '.');
out.textContent = txt.replace(raw, each).replace(/\s*\b[A-Z]{3}\s*$/, '').replace(/\s+/g, ' ').trim();
};
update();
if (window.MutationObserver) new MutationObserver(update).observe(p, { childList: true, characterData: true, subtree: true });
}

/* ---------- Compare-at price: keep the shop's own value ----------
Zepto writes its calculated price into every price node of the theme, the struck-through one included, so the
page showed the sale price twice (seen 2026-10-12: 199,99 struck through instead of 249,00). The struck-through
price is put back from the variant's own compare-at value; it is hidden when the calculated price reaches it. */
function keepCompareAt() {
var box = document.querySelector('.hdt-section--feature-product .hdt-product__price');
var cmp = box && box.querySelector('hdt-compare-at-price .hdt-money');
var cents = parseInt(cfgAttr('compare-cents', '0'), 10) || 0;
if (!cmp || !cents) return;
var fix = function () {
var sale = priceEl();
if (!sale) return;
var txt = sale.textContent, m = txt.match(/\d[\d.,]*/);
if (!m) return;
var raw = m[0], dec = /[.,]\d{2}$/.test(raw) ? raw.charAt(raw.length - 3) : '';
var num = parseFloat(raw.replace(dec === ',' ? /\./g : /,/g, '').replace(',', '.'));
var want = txt.replace(raw, (cents / 100).toFixed(2).replace('.', dec || '.')).replace(/\s+/g, ' ').trim();
var hide = isFinite(num) && Math.round(num * 100) >= cents;
if (cmp.parentNode.hidden !== hide) cmp.parentNode.hidden = hide;
if (cmp.textContent.replace(/\s+/g, ' ').trim() !== want) cmp.textContent = want;
};
fix();
if (window.MutationObserver) new MutationObserver(fix).observe(box, { childList: true, characterData: true, subtree: true });
}

/* ---------- Linked copies must follow their original ----------
Zepto links same-named fields across views (the "On bike" original and its "2D template" copy). A condition
that makes such a copy depend on a value of its own original removes the copy for every other value, so the
2D view and the 2D preview lose that layer (seen 2026-10-12: "Designs" in View 2D only existed while the
original was "Design 1"). Such a self-referencing condition is dropped from this page's copy of Zepto's
settings, and only while the copy is still on the page. Nothing is saved in Zepto; once the condition is
removed in the Zepto app this does nothing. */
function fixLinkedConditions(tries) {
tries = tries || 0;
var again = function () { if (tries < 200) setTimeout(function () { fixLinkedConditions(tries + 1); }, 100); };
var pp = window.product_personalizer, vals = window.pplr_values;
if (!pp || typeof pp.conditions !== 'string' || !vals || !document.querySelector('form.pplr_atc_form .pplr-wrapper')) { again(); return; }
try {
var c = JSON.parse(pp.conditions), changed = false, waiting = false;
var meta = function (n) { var v = vals[n]; return v && v.length > 92 ? { label: String(v[8]).trim(), view: v[92] } : null; };
Object.keys(c).forEach(function (k) {
var m = /^condition_(\d+)$/.exec(k), self = m && meta(m[1]), rules = c[k] && c[k].value;
if (!self || !self.view || !rules || typeof rules !== 'object') return;
var keys = Object.keys(rules);
var linked = keys.length > 0 && keys.every(function (r) {
var src = rules[r] && meta(rules[r][0]);
return src && src.view && src.view !== self.view && src.label === self.label;
});
if (!linked) return;
if (!document.querySelector('form.pplr_atc_form .pplr-wrapper[data-main="' + m[1] + '"]')) { waiting = true; return; }
delete c[k];
changed = true;
});
if (changed) pp.conditions = JSON.stringify(c);
if (waiting) again();
} catch (err) { if (window.console) console.warn('EFP linked-condition check skipped', err); }
}

/* ---------- Faster option changes ----------
After every field change Zepto runs pplr_hide_duplicate(): it shows every linked copy and hides it again,
one jQuery show/hide at a time. Each of those forces the browser to recalculate styles, which took about
0.9 of the 1.1 seconds a click blocked this page (measured 2026-10-13, also without this layer). The
function only sets display, disabled and three marker classes, and its result depends only on the state of
the fields at the moment it is called. Only the elements that function can touch are looked at: the field
wrappers, their inputs with the input's parent, and the label and colour list of a field. The first time a
state is seen Zepto's function runs as usual and its settled result is remembered; the next time the same
state comes in, that result is applied directly.
Any state not seen before, a hidden tab, or a setup with checkbox reordering always takes Zepto's own path.
Set data-fast="0" on .efp-intro to switch this off. */
function fastDuplicates() {
var orig = window.pplr_hide_duplicate;
if (typeof orig !== 'function' || orig.efpFast || window.pplr_has_checkbox || cfgAttr('fast', '1') === '0') return;
var known = {}, count = 0, timer = null;
var state = function (e) {
var c = e.classList;
return e.style.display + '~' + (e.disabled ? 1 : 0) + (c.contains('p_h_d_p') ? 1 : 0) + (c.contains('p_s_d_p') ? 1 : 0) + (c.contains('pplr_hide_duplicate') ? 1 : 0);
};
var PICK = 'input,select,textarea,.pplrlabel,.pplrgcolor,.dropdowncolor';
var read = function () {
var ws = form.querySelectorAll('.pplr-wrapper'), nodes = [], sig = [window.pplr_current_view || ''];
var add = function (e) { nodes.push(e); sig.push(state(e)); };
for (var i = 0; i < ws.length; i++) {
var w = ws[i], all = w.querySelectorAll(PICK), par = null;
sig.push('#' + (w.getAttribute('data-id') || '') + (w.offsetWidth || w.offsetHeight ? 'v' : 'h'));
add(w);
for (var k = 0; k < all.length; k++) {
var e = all[k], p = e.parentNode;
if (/^(INPUT|SELECT|TEXTAREA)$/.test(e.tagName) && p !== w && p !== par) { par = p; add(p); }
add(e);
}
}
return { nodes: nodes, sig: sig.join('|') };
};
var apply = function (nodes, out) {
for (var i = 0; i < nodes.length; i++) {
var e = nodes[i], o = out[i];
if (state(e) === o) continue;
var cut = o.lastIndexOf('~'), disp = o.slice(0, cut), bits = o.slice(cut + 1), c = e.classList;
if (e.style.display !== disp) e.style.display = disp;
if ('disabled' in e && e.disabled !== (bits.charAt(0) === '1')) e.disabled = bits.charAt(0) === '1';
c.toggle('p_h_d_p', bits.charAt(1) === '1');
c.toggle('p_s_d_p', bits.charAt(2) === '1');
c.toggle('pplr_hide_duplicate', bits.charAt(3) === '1');
}
};
var learn = function (key, nodes) {
var last = '', tries = 0;
(function poll() {
timer = setTimeout(function () {
for (var i = 0; i < nodes.length; i++) if (!nodes[i].isConnected) return;
var out = nodes.map(state), now = out.join('|');
var busy = window.jQuery && jQuery.timers && jQuery.timers.length;
if (!busy && now === last) { if (count < 40) { known[key] = out; count++; } return; }
last = now;
if (++tries < 30) poll();
}, 90);
})();
};
var fast = function (e) {
clearTimeout(timer);
var snap = null;
try { snap = read(); } catch (err) { snap = null; }
if (!snap) return orig.apply(this, arguments);
var key = (e ? '1' : '0') + snap.sig, hit = known[key];
if (hit && hit.length === snap.nodes.length) { apply(snap.nodes, hit); return; }
var r = orig.apply(this, arguments);
learn(key, snap.nodes);
return r;
};
fast.efpFast = true;
window.pplr_hide_duplicate = fast;
}

/* ---------- Preview: no blank frame, and a zoom of the customer's own design ----------
Zepto removes its preview for a moment while it redraws; the last frame is kept underneath until the new one
is there. A click on the preview opened the theme's lightbox with the stored product photo; it now opens the
live design instead. The click is stopped on Zepto's own media box, after Zepto's handlers have run. */
function smoothPreview() {
var media = document.querySelector('.hdt-product__media.pplr');
var host = media && (media.closest('.hdt-product-media__main') || media.parentNode);
if (!host || !window.MutationObserver) return;
var ghost = null, timer = null;
var drop = function () { if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost); ghost = null; };
var canvasIn = function (n) { return n.nodeType !== 1 ? null : n.tagName === 'CANVAS' ? n : n.querySelector ? n.querySelector('canvas') : null; };
new MutationObserver(function (list) {
for (var i = 0; i < list.length; i++) {
var k, old, rec = list[i];
for (k = 0; k < rec.removedNodes.length; k++) {
old = canvasIn(rec.removedNodes[k]);
if (!old || !old.width || media.querySelector('canvas')) continue;
try {
clearTimeout(timer); drop();
ghost = document.createElement('canvas'); ghost.className = 'efp-ghost'; ghost.setAttribute('aria-hidden', 'true');
ghost.width = Math.min(old.width, 1000); ghost.height = Math.round(ghost.width * old.height / old.width);
ghost.getContext('2d').drawImage(old, 0, 0, ghost.width, ghost.height);
host.insertBefore(ghost, host.firstChild);
} catch (err) { drop(); }
}
for (k = 0; k < rec.addedNodes.length; k++) if (ghost && canvasIn(rec.addedNodes[k])) { clearTimeout(timer); timer = setTimeout(drop, 400); }
}
}).observe(media, { childList: true, subtree: true });
}
function openZoom() {
var c = document.querySelector('.hdt-product__media.pplr canvas');
if (!c || !c.width || document.querySelector('.efp-zoom')) return;
var copy = document.createElement('canvas');
try { copy.width = c.width; copy.height = c.height; copy.getContext('2d').drawImage(c, 0, 0); } catch (err) { return; }
copy.className = 'efp-zoom__img';
var z = el('div', 'efp-zoom'), x = el('button', 'efp-zoom__close', '<span aria-hidden="true">&times;</span>');
z.setAttribute('role', 'dialog'); z.setAttribute('aria-modal', 'true'); z.setAttribute('aria-label', 'Your design, enlarged');
x.type = 'button'; x.setAttribute('aria-label', 'Close');
z.appendChild(copy); z.appendChild(x);
var back = document.activeElement, html = document.documentElement, overflow = html.style.overflow;
var onKey = function (e) {
if (e.key === 'Escape') { e.preventDefault(); close(); }
else if (e.key === 'Tab') { e.preventDefault(); x.focus(); }
};
var close = function () {
document.removeEventListener('keydown', onKey, true);
if (z.parentNode) z.parentNode.removeChild(z);
html.style.overflow = overflow;
if (back && back.focus) back.focus({ preventScroll: true });
};
z.addEventListener('click', close);
document.addEventListener('keydown', onKey, true);
html.style.overflow = 'hidden';
document.body.appendChild(z);
z.scrollLeft = (z.scrollWidth - z.clientWidth) / 2;
x.focus({ preventScroll: true });
}
function bindZoom() {
var media = document.querySelector('.hdt-product__media.pplr');
if (!media) return;
var down = null;
media.addEventListener('pointerdown', function (e) { down = [e.clientX, e.clientY]; });
media.addEventListener('click', function (e) {
var t = e.target;
if (document.querySelector('.efp-zoom') || (t.closest && t.closest('.pplr_arrows, .pplr_prev_type_wrapper, button, a, input'))) return;
e.stopPropagation();
var layer = media.querySelector('.pplr_ov_layer');
if (layer && layer.children.length) return;
if (down && e.clientX + e.clientY > 0 && (Math.abs(e.clientX - down[0]) > 8 || Math.abs(e.clientY - down[1]) > 8)) return;
openZoom();
});
document.body.classList.add('efp-zoom-on');
}

function init(tries) {
tries = tries || 0;
form = document.querySelector('form.pplr_atc_form');
root = form && form.querySelector('.product-personalizer');
if (!root || !root.querySelector('.pplr-wrapper')) {
if (tries < 80) setTimeout(function () { init(tries + 1); }, 250);
return;
}
CAT = window.EFP_CATALOG || null;
if (!CAT && tries < 80 && document.querySelector('script[src*="efp-configurator-catalog"]')) { setTimeout(function () { init(tries + 1); }, 250); return; }
HELMET = helmetConfig();
if (HELMET) STEPS[0] = HELMET_STEP;
build();
bindForm();
if (HELMET) { try { if (!buildHelmet()) bike = null; } catch (err) { if (bike && bike.parentNode) bike.parentNode.removeChild(bike); bike = null; document.body.classList.remove('efp-bike-on'); if (window.console) console.warn('EFP helmet selector disabled', err); } }
else if (CAT && CAT.c) { try { if (buildBike()) { pushToZepto(); renderBike(); } else bike = null; } catch (err) { if (bike && bike.parentNode) bike.parentNode.removeChild(bike); bike = null; document.body.classList.remove('efp-bike-on'); if (window.console) console.warn('EFP bike selector disabled', err); } }
document.body.classList.add('efp-cfg-on');
go(1, false);
bindIntro();
bindCatnav();
keepCompareAt();
buildViewSwitch();
watchLinkedImageGroups();
try { fastDuplicates(); } catch (err) { if (window.console) console.warn('EFP helper skipped', err); }
(function wait(n) {
if (document.querySelector('.hdt-product__media.pplr canvas')) [smoothPreview, bindZoom].forEach(function (fn) { try { fn(); } catch (err) { if (window.console) console.warn('EFP helper skipped', err); } });
else if (n < 80) setTimeout(function () { wait(n + 1); }, 250);
})(0);
}
fixLinkedConditions();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
else init();
})();
